import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { endpoints } from './endpoints';

import { TipoEstablecimiento } from '../models/tipo-establecimiento.model';
import { TipoPoder } from '../models/tipo-poder.model';
import { TipoProducto } from '../models/tipo-producto.model';
import { TipoDispositivo } from '../models/tipo-dispositivos.model';
import { TipoQuimicos } from '../models/tipo-quimicos.model';
import { TipoCosmetico } from '../models/tipo-cosmetico.model';
import { TipoEstablecimientoPostRegistro } from '../models/tipo-establecimiento.post-registro.model';
import { TramitesPendientes } from '../models/tramites-pendientes.model';
import { TipoLotesVacunas } from '../models/tipo-lotes-vacunas';
import { DatosMercado } from '../models/datos-mercado.model';
import {TipoEstupefacientes} from '../models/tipo-estupefacientes.model';
import { environment } from '../../environments/environment';
import { Departamentos, Municipios } from '../models/entidades.model';
import { TiposVeterinarios } from '../models/tipo-veterinarios.model';

@Injectable({
  providedIn: 'root',
})
export class CatalogosService {
  constructor(private http: HttpClient) {}

  getTiposEstablecimientos(): Observable<TipoEstablecimiento[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposEstablecimientos).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoEstablecimiento();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    );
  }

  getTramitesPendientes(): Observable<TramitesPendientes[]> {
    return this.http.get(endpoints.catalogos.obtenerTramitesPendientes).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.data;
        }
      })
    );
  }

  getTiposEstablecimientosPR(): Observable<TipoEstablecimientoPostRegistro[]> {
    return this.http
      .get(endpoints.catalogos.obtenerTiposEstablecimientosPR)
      .pipe(
        map((result: any) => {
          if (result && result.data) {
            return result.data.map((item) => {
              const tipo = new TipoEstablecimientoPostRegistro();
              tipo.codigo = item.attributes.codigo_proceso;
              tipo.nombre = item.attributes.nombre_proceso;
              tipo.descripcion = item.attributes.descripcion;
              tipo.imagen = this.replacePath(item.attributes.image_path);
              return tipo;
            });
          }
          return [];
        })
      );
  }

  getTiposPoderes(): Observable<TipoPoder[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposPoderes).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoPoder();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    );
  }

  getTiposPoderesPR(): Observable<TipoPoder[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposPoderesPR).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoPoder();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    );
  }

  getTiposContratos(): Observable<TipoPoder[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposContratos).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoPoder();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    );
  }

  getTiposContratosPR(): Observable<TipoPoder[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposContratosPR).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoPoder();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    );
  }

  getTiposFarmaceuticos(): Observable<TipoProducto[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposFarmaceuticos).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoProducto();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    );
  }

  getTiposAnalisisLaboratorios(): Observable<TipoProducto[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposAnalisisLaboratorios).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoProducto();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    );
  }

  getTiposProductosPR(tipo: string, area: string): Observable<TipoProducto[]> {
    let url,
      urlArea = '';
    switch (tipo) {
      case 'farmaceuticos':
        urlArea =
          endpoints.catalogos.obtenerTiposFarmaceuticosGeneral +
          '?filter[area]=' +
          area;
        url = endpoints.catalogos.obtenerTiposFarmaceuticosPR;
        break;
      case 'dispositivos':
        urlArea =
          endpoints.catalogos.obtenerTiposDispositivosGeneral +
          '?filter[area]=' +
          area;
        url = endpoints.catalogos.obtenerTiposDispositivosPR;
        break;
      case 'cosmeticos':
        urlArea =
          endpoints.catalogos.obtenerTiposCosHigGeneral +
          '?filter[area]=' +
          area +
          '&filter[tipo_registro]=POS-COS';
        url = endpoints.catalogos.obtenerTiposCosmeticosPR;
        break;
      case 'higienicos':
        urlArea =
          endpoints.catalogos.obtenerTiposCosHigGeneral +
          '?filter[area]=' +
          area +
          '&filter[tipo_registro]=POS-HIG';
        url = endpoints.catalogos.obtenerTiposHigienicosPR;
        break;
      case 'quimicos':
        if (area === 'certificaciones-constancias'){
          urlArea = endpoints.catalogos.obtenerTiposQuimicosGeneral + '?filter[area]=CC';
        } else if(!area || area === ''){
          urlArea = endpoints.catalogos.obtenerTiposQuimicosGeneral + '?filter[tipo_registro]=POS';
          area= 'pos';
        } else {
          urlArea = endpoints.catalogos.obtenerTiposQuimicosGeneral + '?filter[area]=' + area;
        }
        url = endpoints.catalogos.obtenerTiposQuimicosPR;
        break;
      case 'estupefacientes':
        urlArea = endpoints.catalogos.ObtenerTiposProcesosEstupefacientesGeneral + '?filter[area]=' + area;
        url = endpoints.catalogos.ObtenerTiposProcesosEstupefacientesPR;
        break;
      case 'contratos':
        url = endpoints.catalogos.obtenerTiposContratosPR;
        break;
      case 'establecimientos':
        if(area === 'apertura') {
          urlArea = endpoints.catalogos.obtenerTiposEstablecimientosArea + '?filter[area]=APR';
        } else {
          urlArea = endpoints.catalogos.obtenerTiposEstablecimientosArea + '?filter[tipo_registro]=POS';
        }
        break;
    }

    if (area && area !== '') {
      return this.http.get(urlArea).pipe(
        map((result: any) => {
          if (result && result.data) {
            return result.data.map((item) => {
              const tipoP = new TipoProducto();
              tipoP.codigo = '/'+tipo+'/' + item.attributes.codigo_proceso;
              tipoP.nombre = item.attributes.nombre_proceso;
              tipoP.descripcion = item.attributes.descripcion;
              tipoP.imagen = this.replacePath(item.attributes.image_path);
              return tipoP;
            });
          }
          return [];
        })
      );
    } else {
      return this.http.get(url).pipe(
        map((result: any) => {
          if (result && result.data) {
            return result.data.map((item) => {
              const tipo = new TipoProducto();
              tipo.codigo = item.attributes.codigo_proceso;
              tipo.nombre = item.attributes.nombre_proceso;
              tipo.descripcion = item.attributes.descripcion;
              tipo.imagen = this.replacePath(item.attributes.image_path);
              return tipo;
            });
          }
          return [];
        })
      );
    }
  }

  getTiposProcesosEstupefacientes(): Observable<TipoEstupefacientes[]> {
    return this.http.get(endpoints.catalogos.ObtenerTiposProcesosEstupefacientes).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoEstupefacientes();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    )
  }

  getDatosMercado(): Observable<DatosMercado[]> {
    return this.http.get(endpoints.catalogos.ObtenerDatosMercado).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new DatosMercado();
            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);
            return tipo;
          });
        }

        return [];
      })
    );
  }

  getTiposDispositivos(): Observable<TipoPoder[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposDispositivos).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoDispositivo();
            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);
            return tipo;
          });
        }

        return [];
      })
    );
  }

  getTiposQuimicos(): Observable<TipoPoder[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposQuimicos).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoQuimicos();
            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);
            return tipo;
          });
        }
        return [];
      })
    );
  }

  getTiposLotesVacunas(): Observable<TipoLotesVacunas[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposLotesVacunas).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoLotesVacunas();
            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);
            return tipo;
          });
        }
        return [];
      })
    );
  }
  getTiposPublicidad(): Observable<TipoPoder[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposPublicidad).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoQuimicos();
            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);
            return tipo;
          });
        }
        return [];
      })
    );
  }

  getTiposCosmeticos(): Observable<TipoCosmetico[]> {
    return this.http.get(endpoints.catalogos.obtenerTiposCosmeticos).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoProducto();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);
            return tipo;
          });
        }
        return [];
      })
    );
  }

  getHistorialSolicitud(idInstancia) {
    return this.http
      .get(endpoints.catalogos.historialSolicitudes + idInstancia)
      .pipe(
        map((result: any) => {
          if (result && result.data) {
            return result;
          }
          return [];
        })
      );
  }

  getFechaHabil(fecha, dias): Observable<any> {
    return this.http.get(endpoints.catalogos.getFechaHabil+'/'+fecha+'/'+dias);
  }

  getDataFromCatalog(catalog: string, searchString: string): Observable<any> {
    const url = environment.catalogosUrl + '/' + catalog + '/' + searchString;
    return this.http.get(url).pipe(
        map((response: any) => { return response.data; })
    );
  }

  searchTramite(searchString: string): Observable<any> {
    const url = endpoints.catalogos.searchTramites + '/' + searchString;
    return this.http.get(url).pipe(
        map((response: any) => { return response; })
    );
  }

  replacePath(path: string): string {
    return path.replace('/assets', 'assets');
  }

  getEntidades():Observable<any> {
    return this.http.get<any>(endpoints.catalogos.entidades);
  }

  getPersona(dui:string):Observable<any> {
    return this.http.get<any>(endpoints.catalogos.persona+'/'+ dui);
  }

  getTipoComprobante():Observable<any> {
    return this.http.get<any>(endpoints.catalogos.tipoComprobante);
  }

  getDepartamentos():Observable<Departamentos[]> {
    return this.http.get(endpoints.catalogos.departamentos).pipe(
      map((result: any)=> {
        if (result && result.data) {
          return result.data.map((item) => {
            const departamento = new Departamentos();
            departamento.id = item.attributes.id_departamento;
            departamento.nombre = item.attributes.nombre;
            departamento.activo = item.attributes.activo;
            departamento.id_zona = item.attributes.id_zona;
            departamento.zona_nombre = item.attributes.zona_nombre;
            return departamento;
          });
        }
        return [];
      }));
  }

  getMunicipios():Observable<Municipios[]> {
    return this.http.get(endpoints.catalogos.municipios).pipe(
      map((result: any)=> {
        if (result && result.data) {
          return result.data.map((item) => {
            const municipio = new Municipios();
            municipio.id = item.id;
            municipio.nombre = item.attributes.nombre;
            municipio.activo = item.attributes.activo;
            return municipio;
          });
        }
        return [];
      }));
  }

  getTiposAlimentosYBebidas(): Observable<TipoPoder[]> {
    return this.http.get(endpoints.catalogos.alimentosYBebidas).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TipoPoder();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    );
  }
  getEntidadesLista():Observable<any> {
    return this.http.get<any>(endpoints.catalogos.entidadesLista);
  }
  

  guardarEntidadNatural (request: any): Observable<any> {
    return this.http.post(endpoints.catalogos.saveEntidadNatural, request);
  }

  getTiposVeterinarios(): Observable<TiposVeterinarios[]> {
    return this.http.get(endpoints.catalogos.tiposVeterinarios).pipe(
      map((result: any) => {
        if (result && result.data) {
          return result.data.map((item) => {
            const tipo = new TiposVeterinarios();

            tipo.codigo = item.attributes.codigo_proceso;
            tipo.nombre = item.attributes.nombre_proceso;
            tipo.descripcion = item.attributes.descripcion;
            tipo.imagen = this.replacePath(item.attributes.image_path);

            return tipo;
          });
        }

        return [];
      })
    );
  }

  searchMandamiento(numeroMandamiento: string): Observable<any> {
    let params = {
      num_mandamiento: numeroMandamiento
    };
    return this.http.get(endpoints.colecturia.searchMandamiento, {params}).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  getTokenSerfinsa(idMandamiento: string, monto: number): Observable<any> {
    const headers = new HttpHeaders({
        'Content-Type': 'application/json',
    });
    let parametros = {
        idMandamiento,
        monto,
    };
    return this.http
      .post(
          endpoints.colecturia.generarTokenSerfinsa,
          JSON.stringify(parametros),
          { headers }
      )
      .pipe(
          map((response: any) => {
              return response.data;
          }),
          catchError((error) => {
              throw new Error(error);
          })
      );
  }

  generarComprobanteSerfinsa(idMandamiento: string): Observable<any> {
    return this.http.get(endpoints.reportes.comprobanteSerfinsa + '?clientIdTransaction=' + idMandamiento, {responseType: 'blob'});
  }  
}
